import { Error403Unauthorized } from '@app/components';
import { EditProductGroupSalePriceModal } from '@app/components/Modals';
import { PF } from '@app/pages/Warehouses/PurchasePlanningSettings/data';
import {
  usePurchasePlanningSettings,
  usePurchasePlanningSettingsEffects,
} from '@app/pages/Warehouses/PurchasePlanningSettings/hooks';
import {
  Filters,
  Table,
} from '@app/pages/Warehouses/PurchasePlanningSettings/ui';
import { FiltersAccordion } from '@app/shared/components';

import '@pages/Warehouses/PurchasePlanningSettings/styles/PurchasePlanningSettings.scss';

export const PurchasePlanningSettings = () => {
  const {
    isPageForbidden,
    isFiltersDisabled,
    getProductsLimitsFiltersDataHandler,
    productCategoriesOptions,
    warehousesOptions,
    unsavedFilters,
    isPageLoading,
    range,
    pagination,
    onSearch,
    onReset,
    columns,
    productsLimitsData,
    isFetching,
    onPaginate,
    onPageSizeChange,
    onFiltersChange,
    stockControlRow,
    isStockControlModalOpen,
    closeStockControlModal,
    warehouseNameForModal,
    warehouseId,
  } = usePurchasePlanningSettings();

  usePurchasePlanningSettingsEffects({
    getProductsLimitsFiltersDataHandler,
  });

  if (isPageForbidden) {
    return <Error403Unauthorized />;
  }

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            disabled={isFiltersDisabled}
            onSearch={onSearch}
            onReset={onReset}
            warehousesOptions={warehousesOptions}
            productCategoriesOptions={productCategoriesOptions}
            values={unsavedFilters}
            onFiltersChange={onFiltersChange}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <Table
          columns={columns}
          isPageLoading={isPageLoading}
          isFetching={isFetching}
          data={productsLimitsData ?? []}
          pagination={pagination}
          range={range}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
        />
      </div>

      {!!stockControlRow && (
        <EditProductGroupSalePriceModal
          open={isStockControlModalOpen}
          productId={stockControlRow.ProductId}
          warehouseId={warehouseId}
          productName={stockControlRow.Name}
          warehouseName={warehouseNameForModal}
          onClose={closeStockControlModal}
          forceLeftoverControl
        />
      )}
    </div>
  );
};
